<ng-container *appTranslate="let t">
  <div class="formgrid grid p-fluid">
    <div class="field col-12 lg:col-6">
      <label
        >{{ t("languageTrainingTracking.languageLevelTestResult.title") }}
        <i
          class="pi pi-info-circle ml-1"
          [pTooltip]="t('languageTrainingTracking.languageLevelTestResult.tooltip')"
        ></i>
      </label>

      <input pInputText [ngModel]="languageLevelLabel" [readonly]="true" />
    </div>

    <div class="field col-12 lg:col-6">
      <label>{{ t("languageTrainingTracking.languageLevelTestDate.title") }}</label>
      <i class="pi pi-info-circle ml-1" [pTooltip]="t('languageTrainingTracking.languageLevelTestDate.tooltip')"></i>
      <app-datepicker
        [ngModel]="exam?.examDateAndTime?.date"
        [readonly]="true"
        [showIcon]="false"
        placeholder=""
        [showTime]="exam?.examDateAndTime?.hasTime"
      ></app-datepicker>
    </div>
  </div>
</ng-container>
